import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'components/alert';
import { LayoutVertical } from 'components/layouts';

// https://kentcdodds.com/blog/use-react-error-boundary-to-handle-errors-in-react
function ErrorFallback({ error }) {
  return (
    <div>
      <LayoutVertical>
        <Alert type="error" message="Something went wrong">
          <pre>{error.message}</pre>
        </Alert>
      </LayoutVertical>
    </div>
  );
}

ErrorFallback.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }).isRequired,
};

export default ErrorFallback;
